module.exports = __webpack_public_path__ + "img/icon7.58781027.png";